<template>

  <div>

    <data-table
    ref="permitsduetable"
    table-ref="permitsduetable"

    title="Permits Due Report"
    icon="fa fa-list"

    url="/permits"
    :fields="fields"

    sort-field="expiry"
    detail-component="permits-detail-row" >

    </data-table>


  <br />

  <events-calendar category="permits" />

</div>
</template>

<script>
import Vue from 'vue'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import {settings} from '@/components/Data'

import EventsCalendar from '@/components/atoms/EventsCalendar'
import PermitControls from '@/components/sites/permits/PermitControls'
import PermitDetails from '@/components/sites/permits/PermitDetails'

Vue.component('permits-detail-row', PermitDetails)
Vue.component('permit-controls', PermitControls)


export default {
  mixins: [DateMixins, NumberMixins],

  components: {
    EventsCalendar,
    PermitControls,
    PermitDetails,
  },

  data () {
    return {
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'site_id'
        },
        {
          name: 'site.siteName',
          title: 'Site',
        },
        {
          name: 'site.siteId',
          title: 'Site ID',
        },
        {
          name: 'permitType',
          title: 'Type',
          sortField: 'permitType'
        },
        {
          name: 'applied',
          title: 'Applied',
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'issued',
          title: 'Issued',
          callback: this.formatDate,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'expiry',
          title: 'Expiry',
          callback: this.formatDate
        },
        {
          name: 'amount',
          title: 'Amount',
          callback: this.formatNumber
        },
        {
          name: 'renewalPeriod',
          title: 'Period',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'ref1',
          title: settings.ref1Label,
          sortField: 'ref1',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'ref2',
          title: settings.ref2Label,
          sortField: 'ref2',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: '__component:permit-controls',
          title: ''
        }
      ]
    }
  }
}
</script>
